import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
export var getComponentData = function getComponentData(routeData) {
  var excludedKeys = ['redirect_code', 'relative_url'];
  return Object.fromEntries(Object.entries(routeData).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        key = _ref2[0];

    return !excludedKeys.includes(key);
  }));
};